import { APIPersonalAutoApplicationForm } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';

export const processExceptionalUsageData = (
  applicationData: APIPersonalAutoApplicationForm,
  validation?: Validation,
  remarks?: Remark[],
): BinderSectionData => {
  // Check if any vehicle has exceptional usage characteristics
  const isValid = !applicationData.vehicles_summary?.is_additional_risk;

  return {
    title: 'Exceptional usage',
    description:
      'Will any of the described automobiles be rented or leased to others, or used to carry passengers for compensation or hire, or haul a trailer, or carry explosives or radioactive material?',
    isValid,
    message: isValid ? undefined : validation?.validation_message,
    data: {
      hasExceptionalUsage:
        applicationData.vehicles_summary?.is_additional_risk || false,
      remarks: remarks.length > 0 ? remarks[0].text : null,
    },
  };
};
